import React, { useEffect } from 'react';
import Label from './Label';

const checkBox = ({
  input,
  label,
  icon,
  defaultValue,
  disabled,
  hideError,
  skipPristine = false,
  meta: { pristine, touched, error, warning },
  labelClass,
  wrapperClass = '',
  touchOnChange = false,
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if ((pristine || skipPristine) && defaultValue !== undefined) {
      input.onChange(String(defaultValue) === 'true');
    }
  }, [defaultValue]);
  return (
    <span>
      <span className={`checkbox-wrap custom-checkbox ${wrapperClass}`}>
        <input
          disabled={disabled}
          type="checkbox"
          id={input.name}
          checked={String(input.value) === 'true'}
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...input}
          onChange={(e) => {
            input.onChange(e);
            if (touchOnChange) {
              input.onBlur(e); // ensures `touched` is triggered
            }
          }}
        />
        <Label
          {...{ input, label, labelClass, icon, htmlFor: input.name }}
          type="checkbox"
        />
      </span>

      {!hideError &&
        touched &&
        ((error && <span className="error">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </span>
  );
};

export default checkBox;
